/**
 * Address-related constants
 */

export const ADDRESS_CONSTANTS = {
  /** Minimum months at address before previous address is required */
  MIN_MONTHS_FOR_PREVIOUS_ADDRESS: 24,
  
  /** Residence type mappings */
  RESIDENCE_TYPES: {
    RENT: 'RENT',
    OWN: 'OWN',
    FAMILY: 'FAMILY',
  } as const,
  
  /** Residence type UI values */
  RESIDENCE_TYPE_UI: {
    RENT: 'rent',
    OWN: 'own',
    FAMILY: 'family',
  } as const,
  
  /** Default country code */
  DEFAULT_COUNTRY: 'US',
  
  /** Date constraints */
  DATE: {
    MIN_YEAR: 1900,
    MAX_FUTURE_YEARS: 10,
  },
} as const

export type ResidenceTypeApi = typeof ADDRESS_CONSTANTS.RESIDENCE_TYPES[keyof typeof ADDRESS_CONSTANTS.RESIDENCE_TYPES]
export type ResidenceTypeUI = typeof ADDRESS_CONSTANTS.RESIDENCE_TYPE_UI[keyof typeof ADDRESS_CONSTANTS.RESIDENCE_TYPE_UI]

